module.exports = __webpack_public_path__ + "static/img/backimg5.9c98db62.png";